export const ANSWER_UPDATED = 'ANSWER_UPDATED';
export const ANSWER_VALIDATED = 'ANSWER_VALIDATED';
export const CONQUEST_STATE_RESET = 'CONQUEST_STATE_RESET';

export const updateAnswer = payload => ({
  type: ANSWER_UPDATED,
  payload
});

export const validateAnswer = (validation) => {
  return {
    type: ANSWER_VALIDATED,
    validation
  };
};

export const resetConquestState = () => {
  return {
    type: CONQUEST_STATE_RESET
  };
};
